import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

//Component
import Receipt from '../../Receipt';
import s from './ViewReceipt.css';

class ViewReceipt extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
  };

  render() {
    const { data, title } = this.props;

    return (
      <div className={cx("print-pageContentWrapper", "print-noMargin")}>
        <h1 className={cx('siteAdminHeading', "hidden-print")}>{title}</h1>
        <Receipt data={data} />
      </div>
    );
  }

}

export default withStyles(s)(ViewReceipt);